import React, { useState } from 'react';
import { connect } from "react-redux";
import { UpdateGate } from '../../../store/actions/gateActions'; 
import { Layout, Row, Col, Descriptions } from 'antd';
import _ from 'lodash';
import 'antd/dist/antd.css';

const { Content, Sider } = Layout;

function GateDiagnostic(props) {
    const { gate } = props;

    const [data, setData] = useState({});

    const FormChange = (e) => {
        let update = data;
        update[e.target.name] = e.target.value;
        setData( update );
    }

    console.log(gate);

    return (
        <div className="col s6" id="gateDiagnostics">
            <Col span={24}>
                <Layout className="site-layout-background" style={{ padding: '24px 0', backgroundColor: "#fff" }}>
                    <Content style={{ padding: '0 24px', minHeight: 280}}>
                        <Row>
                            <Col span={12}>
                                <Descriptions bordered>
                                    <Descriptions.Item label="Primary Model" span={3}>{gate.modelPri}</Descriptions.Item>
                                    <Descriptions.Item label="Input Voltage" span={3}>{gate.voltage_pri}</Descriptions.Item>
                                    <Descriptions.Item label="Current (A)"  span={3}>{gate.current_pri}</Descriptions.Item>
                                    <Descriptions.Item label="Temperature (C)" span={3}>{gate.temp_pri}</Descriptions.Item>
                                    <Descriptions.Item label="Gate Position" span={3}>{gate.position_pri}</Descriptions.Item>
                                    <Descriptions.Item label="Gate Time" span={3}>{new Date(gate.time).toLocaleTimeString()}</Descriptions.Item>
                                    <Descriptions.Item label="Timezone" span={3}>UTC {gate.timeDiff}</Descriptions.Item>
                                </Descriptions>
                            </Col>                        
                            {gate.modelSec && <Col span={12}>
                                <Descriptions bordered>
                                    <Descriptions.Item label="Primary Model" span={3}>{gate.modelSec}</Descriptions.Item>
                                    <Descriptions.Item label="Input Voltage" span={3}>{gate.voltage_sec}</Descriptions.Item>
                                    <Descriptions.Item label="Current (A)"  span={3}>{gate.current_sec}</Descriptions.Item>
                                    <Descriptions.Item label="Temperature (C)" span={3}>{gate.temp_sec}</Descriptions.Item>
                                    <Descriptions.Item label="Gate Position" span={3}>{gate.position_sec}</Descriptions.Item>
                                </Descriptions>
                            </Col>}
                        </Row>
                    </Content>
                </Layout>
            </Col>
        </div>
    );
}

const mapStateToProps = (state) => {
    return { 
        gate:    state.gate.gate,
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        UpdateGate: (gate_id, form_data) => dispatch(UpdateGate(gate_id, form_data)),
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(GateDiagnostic);
